<template>
  <div class="referenzen-container" v-if="referenzenList.length > 0">
    <div class="h2 heading">Referenzen</div>
    <div v-for="(referenzen, referenzenIndex) in referenzenList" :key="referenzenIndex">
      <div class="referenzen" v-if="referenzen['text'] || referenzen['ref']">
        <sup class="ref-index" v-html="referenzen['index']"></sup>
        <div class="ref-text d-inline" v-html="referenzen['text']"></div>
        <div class="ref-url d-inline"
             v-if="referenzen['ref']"
             v-html="'→ '+stringToLink(referenzen['ref'])"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    referenzenList : {
      type: Array,
      default: () => []
    },
  },
  name : "ReferenzComponent",
  computed : {},
  methods : {
    stringToLink(url){
      return `<a href="${url}" target="_blank">${url}</a>`;
    },
    getLinkWithIcon(url){
      const link = this.stringToLink(url);
      return `→ ` + link;
    },
  },
}
</script>

<style lang="scss">

@import '../../css/variables';

.referenzen-container {
  padding-top: 42px;
  padding-bottom: 42px;
  border-top: 2px solid #707070;
  @media screen and (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 60px;
  }
  .heading {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: $color-nochvielvor-black;
    margin-bottom: 13px;
    @media screen and (min-width: 768px) {
      font-size: 30px;
      line-height: 1.07;
      color: #2b2e34;
      margin-bottom: 37px;
    }
  }
  .referenzen {
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: 1.6;
    letter-spacing: normal;
    text-align: left;
    color: #2b2e34;
    @media screen and (min-width: 768px) {
      font-size: 15px;
      line-height: 1.6;
    }
  }
  .ref-url {
    color: $color-nochvielvor-pink;
    a {
      color: inherit;
    }
  }
}

</style>
